import { api } from "../api";
import { CellChange } from "../interface";
import { store } from "../store";
import { lang } from "../lang";
import * as HelperSrc from "../HelperSrc";

async function updateTableData(workbook: string, table: string, data: CellChange[]): Promise<void> {
    if (api.clientApi) {
        await api.clientApi.clientWorkbookTableCreate(store.db ? store.db : "", workbook, table, data).then((response) => {
            if (response instanceof Error || (response.message && response.message.error)) {
                if (response instanceof Error) {
                    HelperSrc.writeLog("error", response);
                } else {
                    store.doNotice(lang[response.message.error]);
                }
            }
        });
    }
}

export { updateTableData };
